define('fetch-scorm',[],function() {

    var fetchScorm = function(options) {
        options = options || {};

        var debugMode = options.debugMode,
            prop = options.scormProp || {};

        return new Promise(function(resolve) {
            var res = {
                entry: '',
                lessonLocationID: '',
                studentID: '',
                progress: {}
            };

            if (!prop.enabled) {
                resolve(res);
            }

            require(['scormPackage'], function(ScormPackage) {
                var scormPackage = new ScormPackage(prop);

                scormPackage.init(debugMode);

                if (debugMode) {
                    console.log('scormPackage.entry - ' + scormPackage.entry);
                    console.log('scormPackage.progress - ' + scormPackage.progress);
                    console.log('scormPackage.lessonLocationID - ' + scormPackage.lessonLocationID);
                    console.log('scormPackage.studentID - ' + scormPackage.studentID);
                }

                resolve(scormPackage);
            });
        });

    };

    return fetchScorm;
});

